import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import calcMastery from 'legacy-src/utility/calcMastery';
import './index.scss';

const PerformanceMarker = (props) => {
  const {
    className,
    points,
    layout,
    showNoResults,
    performanceTiers,
    showPointsPossible = true,
    showScoringDropdown,
    studentScoringCondition,
  } = props;
  let mastery;
  let label = showNoResults
    ? studentScoringCondition
      ? '-'
      : 'No results'
    : '';
  if (props.mastery) {
    mastery = props.mastery;
  } else if (points.possible > 0) {
    mastery = calcMastery(
      (points.total / points.possible) * 100,
      performanceTiers,
    );
    label = showPointsPossible
      ? `${Math.floor(points.total)}/${Math.floor(points.possible)}`
      : points.total;
  } else {
    mastery = 'no_results';
  }
  return (
    <div
      className={cn(className, 'performance_marker', {
        double_column: showScoringDropdown,
      })}
    >
      {layout.includes('verticalBar') && (
        <span className={cn('performance_marker__bar', mastery)} />
      )}
      {layout.includes('totalOverall') && (
        <span className="performance_marker__mastery" data-test-total-overall>
          {label}
        </span>
      )}
    </div>
  );
};

PerformanceMarker.defaultProps = {
  layout: ['totalOverall'],
  showNoResults: true,
  studentScoringCondition: false,
};

PerformanceMarker.propTypes = {
  mastery: PropTypes.oneOf([
    'lowTier',
    'middleTier',
    'highTier',
    'incorrect',
    'correct',
    'none',
    'partial',
    'full',
    'no_results',
    'not_submitted',
    'not_scored',
  ]),
  points: PropTypes.object,
  studentScoringCondition: PropTypes.bool,
};

export default PerformanceMarker;
